export default __webpack_public_path__ + "static/media/Xícara.63bf1a41.svg";